<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <Nav :title="'住院费用'" :fixed="true"> </Nav>
      <div class="top"></div>
    </div>
    <div v-if="empyflag" class="empty">
      <van-empty
        image="https://account.kmmds.top/datainfo_pic/error.png"
        description="暂无预约住院记录"
      />
    </div>
    <!-- <div class="head">
      <div class="title_head">
        <div class="title_head_name">吴俊宇</div>
        <div class="title_head_age"><span class="geary">年龄：</span>21岁</div>
      </div>
      <div class="head_row"><span class="geary">住院号：</span>123456</div>
      <div class="head_row">
        <span class="geary">住院日期：</span>2020.12.31-2021-01.05
      </div>
      <div class="head_row"><span class="geary">住院天数：</span>10</div>
    </div> -->
    <div class="list" v-else>
      <div v-for="(item, key, index) in infolist" :key="index">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item :title="key" :name="index"
            ><div
              class="listcard"
              v-for="(item1, index1) in infolist[key]"
              :key="index1"
            >
              <!-- <div class="listcard_title line">
                <div class="listcard_title_a">{{ item1.ItemName }}</div>
                <div class="listcard_title_b">X{{ item1.Quantity }}</div>
              </div> -->
              <div class="listcard_row">
                <div class="listcard_row_a">费用类型</div>
                <div class="listcard_row_b">{{ item1.feeTypeName }}</div>
              </div>
              <div class="listcard_row">
                <div class="listcard_row_a">类别：</div>
                <div class="listcard_row_b">{{ item1.feeItemName }}</div>
              </div>
              <div class="listcard_row">
                <div class="listcard_row_a">单价：</div>
                <div class="listcard_row_b">{{ item1.price }}元</div>
              </div>
              <div class="listcard_row">
                <div class="listcard_row_a">数量：</div>
                <div class="listcard_row_b">{{ item1.num + item1.unit }}</div>
              </div>
              <div class="listcard_row line">
                <div class="listcard_row_a">科目：</div>
                <div class="listcard_row_b">{{ item1.recipeDeptName }}</div>
              </div>
              <div class="listcard_money">
                金额：<span class="moneycolor">{{ item1.fee }}</span
                >元
              </div>
            </div></van-collapse-item
          >
        </van-collapse>
        <!-- <div class="list_date">{{key}}</div> -->
        <!-- <div class="listcard" v-for="(item1,index1) in infolist[key]" :key="index1">
            <div class="listcard_title line" >
              <div class="listcard_title_a">{{item1.ItemName}}</div>
              <div class="listcard_title_b">X{{item1.Quantity}}</div>
            </div>
            <div class="listcard_row">
              <div class="listcard_row_a">费用类型</div>
              <div class="listcard_row_b">{{item1.PactName}}</div>
            </div>
             <div class="listcard_row">
              <div class="listcard_row_a">类别：</div>
              <div class="listcard_row_b">{{item1.ItemType}}</div>
            </div>
             <div class="listcard_row">
              <div class="listcard_row_a">单价：</div>
              <div class="listcard_row_b">{{item1.Price}}</div>
            </div>
             <div class="listcard_row line">
              <div class="listcard_row_a">科目：</div>
              <div class="listcard_row_b">{{item1.FeeType}}</div>
            </div>
            <div class="listcard_money"> 金额：<span class="moneycolor">{{item1.TotalCost}}</span>元</div>
      </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
export default {
  data() {
    return {
      activeNames: [],
      InPatientId: "",
      BeginDate: "",
      EndDate: "",
      infolist: {},
      empyflag: null,
    };
  },
  components: {
    Nav,
  },
  methods: {
    gettypetotal(typename, obj) {
      let total = 0;
      for (let key in obj) {
        obj[key].forEach((item) => {
          if (item.feeTypeName == typename && item.tradeFlag == "1") {
            total += item.fee;
          }
        });
      }
      return total;
    },
    getalltotal(obj) {
      let total = 0;
      for (let key in obj) {
        obj[key].forEach((item) => {
       
          total += item.fee;
        });
      }
      return total;
    },
    async init() {
      //  console.log(this.EndDate)
      try {
        this.$showLoad();
        let R_data = {
          inPatientId: this.InPatientId,
          beginDate: this.BeginDate,
          endDate: this.EndDate,
        };
        //注册
        let zc_url = "/queryinpatientdailylist";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          zc_url,
          "POST",
          R_data,
          (data) => {
            this.infolist = data.data.data.data;
            if (Object.keys(this.infolist).length === 0) {
              // console.log(1)
              this.empyflag = true;
            } else {
              let cc = this.gettypetotal("检查费", this.infolist);
              let www = this.getalltotal(this.infolist).toFixed(2);
              console.log(www)
              this.empyflag = false;
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("注册并绑定失败, 请核对信息重试");
      }
    },
  },
  mounted() {
    if (this.$route.query) {
      this.InPatientId = this.$route.query.InPatientId;
      this.BeginDate = this.$route.query.BeginDate;
      this.EndDate = this.$route.query.EndDate;
    }
    this.init();
  },
};
</script>

<style lang="scss" >
.main {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100vh;
  .nav {
    height: 6vh;
    .top {
      height: 50px;
    }
  }
  .head {
    width: 100%;
    background-color: #5b8df6;
    height: 20vh;
    display: flex;
    flex-direction: column;
    color: white;
    padding: 15px;
    .title_head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 6vh;
      .title_head_name {
        font-size: 25px;
      }
      .title_head_age {
        font-size: 14px;
      }
    }
    .head_row {
      font-size: 14px;
      line-height: 4vh;
      color: #ffffff;
    }
  }

  .list {
    display: flex;
    flex-direction: column;
    overflow: scroll;
    // background-color: #eee;
    height: 95vh;
    width: 100%;
    .list_date {
      background-color: #eee;
      font-size: 14px;
      color: #666;
      line-height: 28px;
      margin-left: 15px;
    }
    .listcard {
      display: flex;
      flex-direction: column;
      background-color: white;
      width: 100%;
      margin: 0px auto;
      margin-bottom: 8px;
    }
    .listcard_title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 24px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_title_a {
        font-size: 16px;
      }
      .listcard_title_b {
        font-size: 14px;
        color: #999;
      }
    }
    .listcard_row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 15px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_row_a {
        font-size: 14px;
        color: #999;
      }
      .listcard_row_b {
        font-size: 14px;
      }
    }
    .listcard_money {
      line-height: 35px;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 95%;
      text-align: end;
      .moneycolor {
        color: #5b8df6;
        font-weight: bolder;
        font-size: 18px;
      }
    }
  }
  .line {
    border-bottom: 1px solid #eeeeee;
  }
  .geary {
    color: #a1c7f2;
  }
}
.van-collapse-item__content {
  padding: 8px 0px !important;
  color: #969799;
  font-size: 14px;
  line-height: 1.5;
  background-color: #eee !important;
}
</style>